import { Diagram, DiagramEvent, DiagramEventName } from 'gojs';
import castArray from 'lodash/castArray';
import forEach from 'lodash/forEach';

export const addDiagramEventListeners = (
  diagram: Diagram,
  events: DiagramEventName | readonly DiagramEventName[],
  listener: (e: DiagramEvent) => void,
): void => {
  forEach(castArray(events), (event) => {
    diagram.addDiagramListener(event, listener);
  });
};
